/** Product duck-type reader shared by task board and frame event handlers. */
export class AppNodeOf {
    /** DOCUMENTED EXCEPTION: pure type reader. ERROR-SUPPRESSED-JUSTIFIED:
     * callers own gates and catches; a throwing closest getter must propagate to that owner.
     */
    public static Read = <T>(Target: unknown): T | null => {
        if (Target === null || typeof Target !== "object") { return null; }
        if (typeof (Target as Record<string, unknown>).closest !== "function") { return null; }
        return Target as T;
    };
}
